import { render, staticRenderFns } from "./SelectColumns.vue?vue&type=template&id=dafeaa5c&"
import script from "./SelectColumns.vue?vue&type=script&lang=ts&"
export * from "./SelectColumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports